(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  document.querySelectorAll('[data-cof-pointer-art]').forEach(function (panel) {
    var art = panel.querySelector('[data-cof-art]'), frame = 0, point = null;
    if (!art) return;
    function reset() { point = null; if (frame) cancelAnimationFrame(frame); frame = 0; art.style.removeProperty('--art-x'); art.style.removeProperty('--art-y'); }
    panel.addEventListener('pointermove', function (e) {
      if (reduce.matches || !fine.matches || e.pointerType === 'touch') return;
      point = {x:e.clientX,y:e.clientY};
      if (frame) return;
      frame = requestAnimationFrame(function () {
        frame = 0; if (!point) return;
        var r = panel.getBoundingClientRect();
        art.style.setProperty('--art-x', (((point.x-r.left)/r.width-.5)*16).toFixed(2)+'deg');
        art.style.setProperty('--art-y', ((.5-(point.y-r.top)/r.height)*12).toFixed(2)+'deg');
      });
    }, {passive:true});
    panel.addEventListener('pointerleave', reset); reduce.addEventListener('change',reset); fine.addEventListener('change',reset);
  });
  var counter = document.querySelector('[data-cof-cart-count]');
  var cart = document.querySelector('.cofcof-nv-cart');
  if (counter && cart) {
    var previous = Number(counter.textContent)||0, timer;
    new MutationObserver(function () {
      var n = Number(counter.textContent)||0;
      cart.setAttribute('aria-label','Carrinho ('+n+'). Ver meu carrinho');
      if (n>previous && !reduce.matches) {
        cart.classList.remove('is-just-added'); void cart.offsetWidth; cart.classList.add('is-just-added');
        clearTimeout(timer); timer=setTimeout(function(){cart.classList.remove('is-just-added');},750);
      }
      previous=n;
    }).observe(counter,{childList:true,characterData:true,subtree:true});
  }
})();
